import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { messages } from '../../../../helpers/messages';
import { transactionsService } from '../../../../services/transactions-service';
import { userService } from '../../../../services/user-service';
import Loader from './Loader/Loader';
import { TransactionsProducer } from './transactionHelper';
import { methods } from '../helper';
import { ConfirmModal } from '../../../common';
import {
  transactionDate,
  calculationAccess,
  getUserFromLocalStorage, returnAnnuityDealType,
} from '../../../../helpers/common';
import { listRoles } from '../../../../helpers/data-constants';
import { useRecalculation } from '../../../utilites';

import '../../reports.scss';

let SIZE = 10;

let transactionsProducer = TransactionsProducer(transactionsService, userService, SIZE);

const rolesFromaCancelReversal = [
  listRoles.ADMIN,
  listRoles.DIRECTOR,
  listRoles.GOODS_SPECIALIST,
  listRoles.BRANCH_DIRECTOR
];

const Transactions = ({ cashBoxIds, startDate, endDate, section, type, onRevert, cash, cashBox, successRolesAllCash }) => {
  const [state, setState] = useState({
    transactions: [],
    page: 1,
    totalElements: 0,
    loading: false,
  });
  const [revertTransaction, setRevertTransaction] = useState(undefined);

  const showCancelReversalButton = calculationAccess(rolesFromaCancelReversal);
  const userRoles = getUserFromLocalStorage().roles;
  const isGoodsSpecialist = userRoles.includes(listRoles.GOODS_SPECIALIST);
  const { isRecalculationTransaction } = useRecalculation({calc: {}});

  useEffect(() => {
    getTransactions();
  }, [startDate, endDate, cashBoxIds, section, state.page]);

  const error = (err) => {
    if (err.response) {
      let errorData = err.response.data;
      let commonError = messages['0'];
      if (errorData.errorCode) {
        commonError = messages[errorData.errorCode];
      }
      setState((prev) => ({
        ...prev,
        loading: false,
        error: commonError,
      }));
    }
  };

  const getTransactions = () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    
    let args = [startDate, endDate, cashBoxIds, state.page, section, cash]

    if (successRolesAllCash && cashBox.length === 0) {
      args.splice(2, 1, null);
    }
    if((type === 'DEBIT' || type === 'CREDIT') && section === 'NON_CASH_ACCOUNT') {
      args.push(type);
    }

    transactionsProducer
      .getTransactions(...args)
      .then(({ transactions, totalElements }) => {
        if (state.page > 1) {
          transactions = [...state.transactions, ...transactions];
        }
        setState((prev) => ({
          ...prev,
          transactions: transactions,
          totalElements: totalElements,
          loading: false,
        }));
      })
      .catch(error);
  };

  const handleRevert = (transaction) => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    transactionsService
      .revertTransaction(transaction.id)
      .then(() => {
        state.transactions.forEach((tr) => {
          if (tr.id === transaction.id) {
            tr.reverted = true;
          }
        });
        if (onRevert) {
          onRevert();
        }
        setState((prev) => ({
          ...prev,
          transactions: state.transactions,
          loading: false,
        }));
      })
      .catch(() => {
        setState((prev) => ({
          ...prev,
          loading: false,
        }));
      });
  };

  const handleShowMore = () => {
    setState((prev) => ({
      ...prev,
      page: state.page + 1,
    }));
  };

  const returnButton = (transaction) => {
    if (userRoles.length) {
      const accessRoles = userRoles.filter(
        (i) => i === listRoles.ADMIN || i === listRoles.DIRECTOR ||i === listRoles.BRANCH_DIRECTOR,
      ).length;

      if (!isGoodsSpecialist && userRoles.length === 1) {
        return (
          <button
            className="button-tab transaction-button"
            onClick={() => {
              setRevertTransaction(transaction);
            }}>
            Отменить
          </button>
        );
      } else {
        if (accessRoles) {
          return (
            <button
              className="button-tab transaction-button"
              onClick={() => {
                setRevertTransaction(transaction);
              }}>
              Отменить
            </button>
          );
        }
        else {
          if (
            moment(moment(transaction.createDate).utc().format('YYYY-MM-DD'))
              .isSame( moment().utc().format('YYYY-MM-DD'))
            ||
            moment(moment(transaction.createDate).utc().format('YYYY-MM-DD'))
              .isSame(moment().utc().add(-1, 'days').format('YYYY-MM-DD'))
          ) {
            return (
              <button
                className="button-tab transaction-button"
                onClick={() => {
                  setRevertTransaction(transaction);
                }}>
                Отменить
              </button>
            );
          }
          else {
            return null;
          }
        }
      }
    }
  };

  return state.loading ? (
    <Loader pageRange={10} />
  ) : (
    <>
      <table className="table fullwidth">
        <thead>
        <tr>
          <th scope="col">Описание</th>
          <th scope="col">Дата</th>
          <th scope="col">Тип договора</th>
          {type === 'CREDIT' && <th scope="col">Приход, BYN</th>}
          {type === 'DEBIT' && <th scope="col">Расход, BYN</th>}
          <th scope="col">Товаровед</th>
          {showCancelReversalButton && <th scope="col"/>}
        </tr>
        </thead>
        <tbody>
        {state.transactions &&
            state.transactions.map((transaction) => {
              return (
                  <tr key={transaction.id} className={transaction.reverted ? 'reverted' : ''}>
                    <th scope="row">
                      <span className="caption">Тип транзакции</span>
                      <p dangerouslySetInnerHTML={{__html: transaction.description.replace(/(Простить проценты = |Простить пени = |Простить неустойку = )(\d+\.\d+)/g, '$1<del>$2</del>')}}></p>
                    </th>
                    <td>
                      <span className="caption">Дата</span>
                      <p>{transactionDate(transaction)}</p>
                    </td>
                    <td>
                      <span className="caption">Тип договора</span>
                      <p>{returnAnnuityDealType(transaction.dealDuration)}</p>
                    </td>
                    {transaction.type === 'CREDIT' && (
                        <td>
                          <span className="caption">Приход, BYN</span>
                          <p>{transaction.amount.toFixed(2)}</p>
                        </td>
                    )}
                    {transaction.type === 'DEBIT' && (
                        <td>
                          <span className="caption">Расход, BYN</span>
                          <p>{transaction.amount.toFixed(2)}</p>
                        </td>
                    )}
                    <td>
                      <span className="caption">Товаровед</span>
                      <p>{transaction.user && transaction.user.fullName}</p>
                    </td>
                    {showCancelReversalButton && (
                        <td>
                          {methods.isRevertable(transaction.section) &&
                              !transaction.reverted &&
                              returnButton(transaction)}
                        </td>
                    )}
                  </tr>
              );
            })}
        </tbody>
      </table>
      {state.totalElements > state.page * SIZE && (
          <div className="content-datatable-header-actions d-flex">
            <div className="content-datatable-header-center">
            <div className="action-items">
              <button className="action-item" onClick={handleShowMore}>
                Показать еще{' '}
                {'( показаны ' + state.page * SIZE + ' из ' + state.totalElements + ')'}
              </button>
            </div>
          </div>
        </div>
      )}
      <ConfirmModal
        isOpen={!!revertTransaction}
        handleClose={() => {
          setRevertTransaction(undefined);
        }}
        handleAction={() => {
          setRevertTransaction(undefined);
          handleRevert(revertTransaction);
        }}
        headerText="Отменить транзакцию"
        bodyText={
          revertTransaction &&
          `Уверены что хотите отменить транзакцию${
            revertTransaction.description ? ' ' + revertTransaction.description : ''
          }?`
        }
      />
    </>
  );
};

export default Transactions;
